<style lang="scss" scoped>
  .header-vkplay {
    position: relative;
    z-index: 10;
    margin-bottom: 120px;
    width: 100%;
    color: #fff;
    background: #006de7;
    border-radius: 0 0 80px 80px;

    @include media(max, lg) {
      margin-bottom: 50px;
      border-radius: 0 0 20px 20px;
    }
  }

  .container {
    margin: 0 auto;
    padding: 0 20px;
    width: 1060px;
    max-width: 100%;
  }

  .wrapper {
    padding: 90px 0 100px;
    display: flex;
    align-items: stretch;

    @include media(max, lg) {
      padding: 0 0 50px;
      flex-direction: column-reverse;
      align-items: center;
    }
  }

  .info {
    position: relative;
    z-index: 1;
    max-width: 500px;

    @include media(max, lg) {
      text-align: center;
    }
  }

  .logo {
    margin-bottom: 30px;
    width: 190px;
    height: 54px;
    background: cdn('images/b2b/header/vkplay-logo.svg') no-repeat center;
    background-size: 100% auto;
  }

  .main-title {
    margin: 0 0 50px;
    font-size: 48px;
    line-height: 1.04;
    font-weight: 600;
    letter-spacing: 0.005em;

    :global(span) {
      color: #69dc9d;
    }

    @include media(max, lg) {
      margin-bottom: 0;
      font-size: 32px;
      line-height: 1.12;
      text-align: left;
    }
  }

  .btn-wrapper {
    position: relative;

    @include media(max, lg) {
      position: fixed;
      z-index: 10;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 20px;
      text-align: center;
      background: linear-gradient(0deg, #000 0%, rgba(0, 0, 0, .7) 50%, rgba(0, 0, 0, .8) 100%);
      border-radius: 20px 20px 0 0;
      transition: all .4s;

      &.is-mobile-hidden {
        opacity: 0;
      }
    }
  }

  .overview-link {
    display: inline-block;
    margin-top: 32px;
    position: relative;
    z-index: 1;
    font-size: 18px;
    line-height: 1.78;
    color: #fff;

    svg {
      display: inline-block;
      vertical-align: -4px;
    }

    [dir=rtl] & {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  .btn-action {
    padding: 12px 20px;
    line-height: 32px;
    background-color: #e2e3e7;
    box-shadow: 0 30px 50px -16px rgba(0, 9, 180, 0.3);
    border-radius: 8px;

    [dir=rtl] & {
      svg {
        transform: rotate(180deg);
      }
    }

    @include media(max, lg) {
      display: block;
      margin-bottom: 8px;

      svg {
        vertical-align: -4px;
      }
    }
  }

  .btn-hint {
    position: absolute;
    left: -17px;
    bottom: calc(100% + 40px);
    font-family: 'Neucha', sans-serif;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.02em;
    max-width: 106px;
    transform: rotate(-14.24deg) translateX(-100%);
    opacity: .8;

    &:after {
      content: '';
      position: absolute;
      top: calc(100% + 15px);
      left: 50%;
      margin-left: 10px;
      width: 45px;
      height: 35px;
      background: cdn('images/b2b/header/arrow.svg') no-repeat center;
      background-size: 100% auto;
      transform: rotate(14.24deg) translateX(-50%);
    }

    [dir=rtl] & {
      left: auto;
      right: -17px;
      transform: rotate(14.24deg) translateX(100%);

      &:after {
        left: auto;
        right: 50%;
        margin-left: 0;
        margin-right: 10px;
        transform: rotate(-14.24deg) translateX(50%) scaleX(-1);
      }
    }

    @media screen and (max-width: 1280px) {
      display: none;
    }

    @include media(max, lg) {
      display: block;
      position: static;
      font-family: inherit;
      font-size: 16px;
      line-height: 1.25;
      letter-spacing: 0.02em;
      max-width: none;
      color: #d8d8d8;
      transform: none;

      &:after {
        display: none;
      }

      [dir=rtl] & {
        transform: none;
      }
    }
  }

  .income-wrapper {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;

    @include media(max, lg) {
      max-width: calc(100% + 40px);
      overflow: hidden;
    }
  }

  .income {
    position: relative;
    width: 100%;

    @include media(max, lg) {
      width: 475px;
      flex: 1 0 475px;
    }
  }

  .income-img {
    content: '';
    position: absolute;
    top: -73px;
    right: -123px;
    width: 762px;
    height: 434px;
    background: cdn('images/b2b/header/header-bg.png') no-repeat center;
    background-size: 100% auto;

    @media (-webkit-min-device-pixel-ratio: 2),
    (min-resolution: 192dpi) {
      background-image: cdn('images/b2b/header/header-bg@2x.png');
    }

    @include media(max, lg) {
      position: static;
      margin-top: 60px;
      width: 100%;
      height: 174px;
      background-image: cdn('images/b2b/header/header-bg-mob.png');
      background-size: auto 100%;

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/header/header-bg-mob@2x.png');
      }
    }
  }

  .income-text {
    position: absolute;
    z-index: 1;
    right: -65px;
    bottom: -18px;
    padding: 35px 90px 98px 56px;
    font-size: 26px;
    line-height: 28px;
    font-weight: 500;
    width: 337px;
    height: 187px;
    background: cdn('images/b2b/header/bubble.png') no-repeat center;
    background-size: 100% auto;

    @media (-webkit-min-device-pixel-ratio: 2),
    (min-resolution: 192dpi) {
      background-image: cdn('images/b2b/header/bubble@2x.png');
    }

    @include media(max, lg) {
      top: 25px;
      right: 28px;
      padding: 18px 66px 75px 48px;
      font-size: 16px;
      line-height: 18px;
      width: 234px;
      height: 123px;
      background-image: cdn('images/b2b/header/bubble-mob.png');

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/header/bubble-mob@2x.png');
      }
    }
  }

</style>

<template>
  <div class="header-vkplay">
    <div class="container">
      <div class="wrapper">
        <div class="info">
          <div class="logo"></div>
          <h1 class="main-title" v-html="$t('mainTitle')"></h1>
          <div class="btn-wrapper" ref="btnWrapper">
            <btn
              href="/dev/developers/register/"
              target="_blank"
              variant="secondary"
              class="fs-18 btn-main btn-action">
              {{$t('btnText')}}
              <icon name="angle"/>
            </btn>
            <div class="btn-hint">
              {{$t('addProject')}}
            </div>
          </div>

          <a href="//documentation.vkplay.ru/overview_vkp/platform_overview_vkp" class="overview-link">
            {{$t('overview')}}
            <icon name="angle"/>
          </a>
        </div>
        <div class="income-wrapper">
          <div class="income">
            <div class="income-img"></div>
            <div class="income-text">
              {{$t('income')}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */

export default {
  name: 'Header',
  i18n: {
    messages: {
      ru: {
        mainTitle: 'Единая точка притяжения для&nbsp;всей <span>игровой аудитории</span> в&nbsp;России',
        addProject: 'Добавьте свой проект',
        btnText: 'Кабинет разработчика',
        income: 'Дохода разработчикам',
        overview: 'Обзор всех возможностей',
      },
      en: {
        mainTitle: 'A single hub for the entire <span>gaming audience</span> in Russia',
        addProject: 'Add your project',
        btnText: 'Developer Dashboard',
        income: 'Income to developers',
        overview: 'An overview of all features',
      },
      de: {
        mainTitle: 'Ein Zentrum für <span>alle Gamer</span> aus ganz Russland',
        addProject: 'Eigenes Projekt hinzufügen',
        btnText: 'Entwickler-Dashboard',
        income: 'Einkommen für Entwickler',
        overview: 'Eine Übersicht über alle Funktionen',
      },
      fr: {
        mainTitle: 'Un hub unique pour l\'ensemble du <span>public des jeux</span> en Russie',
        addProject: 'Ajoutez votre projet',
        btnText: 'Tableau de bord des développeurs',
        income: 'Revenus aux développeurs',
        overview: 'Un aperçu de toutes les fonctionnalités',
      },
      es: {
        mainTitle: 'Una sola plataforma para <span>todos los videojugadores</span> de Rusia',
        addProject: 'Agrega tu proyecto',
        btnText: 'Tablón de desarrolladores',
        income: 'Ingresos a los desarrolladores',
        overview: 'Un resumen de todas las características',
      },
      pl: {
        mainTitle: 'Jedno centrum dla <span>wszystkich graczy</span> w Rosji',
        addProject: 'Dodaj swój projekt',
        btnText: 'Pulpit twórcy',
        income: 'Zyski dla twórców',
        overview: 'Przegląd wszystkich funkcji',
      },
      tr: {
        mainTitle: 'Rusya\'daki tüm <span>oyun meraklıları</span> için tek bir merkez',
        addProject: 'Projeni ekle',
        btnText: 'Geliştirici Paneli',
        income: 'Geliştirici geliri',
        overview: 'Tüm özelliklere genel bakış',
      },
      ar: {
        mainTitle: 'مركز واحد لجميع <span>محبي الألعاب</span> في روسيا',
        addProject: 'أضف مشروعك',
        btnText: 'لوحة تحكم المطور',
        income: 'الدخل للمطورين',
        overview: 'نظرة عامة على جميع الميزات',
      },
    },
  },
  mounted() {
    this.toggleMobileBtnOnScroll();
    window.addEventListener('scroll', this.toggleMobileBtnOnScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.toggleMobileBtnOnScroll);
  },
  methods: {
    toggleMobileBtnOnScroll() {
      const footerElem = document.querySelector('.js-footer-content');
      const btnElem = this.$refs.btnWrapper;

      if (footerElem.classList.contains('in-viewport') || footerElem.classList.contains('above-viewport')) {
        btnElem.classList.add('is-mobile-hidden');
      } else {
        btnElem.classList.remove('is-mobile-hidden');
      }
    },
  },
};

</script>
